import {
  BasicButton,
  BasicInput,
  ModalComponent,
  SelectComponent,
} from "Common/Components";
import React from "react";
import { useFormCreateCorrelative } from "../hooks/useFormCreateCorrelative";
import { useCorrelativeStore } from "../store/useCorrelativeStore";
import { useCorrelativeList } from "../hooks/useCorrelativeList";

interface ModalFormEmployeProps {
  showModal: boolean;
  onHide: () => void;
}

export const ModalFormCreateCorrelative: React.FC<ModalFormEmployeProps> = ({
  showModal,
  onHide,
}) => {
  const { t, isEdith, formik, session, setCompanyId } =
    useFormCreateCorrelative(onHide);

  const { optionBranch, idBranch, setIdBranch } = useCorrelativeStore();
  const { branchSelected } = useCorrelativeList();

  return (
    <ModalComponent
      modalTitle={
        isEdith
          ? t("correlativeScreen.formAdminCorrelative.TitleEdit")
          : t("correlativeScreen.formAdminCorrelative.TitleCreate")
      }
      show={showModal}
      onHide={() => {
        onHide();
        setIdBranch("");
        formik.resetForm();
      }}
      size="xl"
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
        }}
      >
        <div className="w-full">
          <SelectComponent
            label={t("CashRegisterClosingReport.branch")}
            placeholder={t("CashRegisterClosingReport.branch")}
            options={optionBranch}
            id="branch"
            isMulti={false}
            value={
              idBranch
                ? optionBranch.find(opt => opt.value === idBranch)
                : optionBranch.find(opt => opt.value === branchSelected?.toString())
            }

            onChange={(selectedOption) => {
              const newId = selectedOption?.value || "";
              setIdBranch(newId); 
              formik.setFieldValue("branch_id", newId);
            }}

            onBlur={() => { }}
            isError={!!(formik.touched.branch_id && formik.errors.branch_id)}
          />
          {formik.touched.branch_id && formik.errors.branch_id && (
            <p className="mt-1 text-sm text-red-500">
              {formik.errors.branch_id}
            </p>
          )}
        </div>

        <div className="w-full">
          <BasicInput
            label={t("correlativeScreen.formAdminCorrelative.fieldDescription")}
            className="w-auto"
            placeholder={t("correlativeScreen.formAdminCorrelative.placeholderDescription")}
            id="correlative"
            type="text"
            value={formik.values.correlative}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={
              !!(formik.touched.correlative && formik.errors.correlative)
            }
            errorMessage={formik.errors.correlative || ""}
          />
        </div>

        {/* ✅ Botón */}
        <div className="col-span-12">
          <div className="col-span-12">
            <div className="flex justify-end">
              <BasicButton
                disabled={formik.isSubmitting}
                type="submit"
                onClick={() => { }}
              >
                <span className="text-white">
                  {isEdith
                    ? t("correlativeScreen.formAdminCorrelative.TitleEdit")
                    : t("correlativeScreen.formAdminCorrelative.TitleCreate")}
                </span>
              </BasicButton>
            </div>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};
